import {  useEffect} from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { idCardSchema } from "../schemas/idCardSchema";
import { idCardService } from "../services/idCardService";
import { toast } from "../../../services/toastService";
import DeleteConfirmModal from "../../../components/DeleteConfirmModal";

const IdCardForm = ({loadData,id,setId}) => {

  const isEditMode= Boolean(id);
  
  const initialForm = {
    cardNo: "",
    companyName: "",
    iqamaNumber: "",
    operatorName: "",
    trade: "",
    issueDate: "",
    expiryDate: "",
    type:""
  };
  const {
    register,
    handleSubmit,
     reset,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(idCardSchema),
  });
useEffect(() => {
    if(id>0) {
      editAsync();
    }
  }, [id]);
  const editAsync = async () => {
    try {
      const result = await idCardService.edit(id);
      if (!result.isSuccess) {
        toast.error(result.errors[0] || "Failed to edit Id Card");
        return;
      }
      // Fill form data
    reset({
      cardNo: result.value.cardNo,
      companyName: result.value.companyName,
      iqamaNumber: result.value.iqamaNumber,
      operatorName: result.value.operatorName,
      trade: result.value.trade,
      issueDate: result.value.issueDate?.split("T")[0],
      expiryDate: result.value.expiryDate?.split("T")[0],
    });
    } catch (error) {
      toast.error("An error occurred while updating the Id Card");
      console.log(error);
    }
  };
  const onSubmit = async (data) => {
  if(isEditMode) await updateAsync(data); 
  else await addAsync(data);
  };
  const addAsync=async (data)=>{
 try {
    const result = await idCardService.create(data);
    if(!result.isSuccess) {
      toast.error(result.errors[0] || "Failed to create Id Card");
      return;
    }
    console.log(result);
    toast.success("Record added successfully");
    handleClear();
    loadData();
  } catch (error) {
     toast.error("An error occurred while creating the Id Card");
    console.log(error);
  }
  }
  const updateAsync=async (data)=>{
    try {
    const result = await idCardService.update(id,data);
    if(!result.isSuccess) {
      toast.error(result.errors[0] || "Failed to create Id Card");
      return;
    }
    console.log(result);
    toast.success("Record updated successfully");
    handleClear();
    loadData();
  } catch (error) {
     toast.error("An error occurred while creating the Id Card");
    console.log(error);
  }
  }
  const handleClear=()=>{
    setId(0);
    reset(initialForm);
  }

  

  return (
    <section className="section-id-card-form">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Card No.</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Card No."
                {...register("cardNo")}
              />
              <small className="text-danger">
                {errors.iqamaNumber?.message}
              </small>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Iqama No.</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Iqama No."
                {...register("iqamaNumber")}
              />
              <small className="text-danger">
                {errors.iqamaNumber?.message}
              </small>
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group">
              <label>Operator Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Operator Name"
                {...register("operatorName")}
              />
              <small className="text-danger">
                {errors.operatorName?.message}
              </small>
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group">
              <label>Company Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Company Name"
                {...register("companyName")}
              />
              <small className="text-danger">
                {errors.companyName?.message}
              </small>
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group">
              <label>Issue Date</label>
              <input
                type="date"
                className="form-control"
                {...register("issueDate")}
              />
              <small className="text-danger">{errors.issueDate?.message}</small>
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group">
              <label>Expiry Date</label>
              <input
                type="date"
                className="form-control"
                {...register("expiryDate")}
              />
              <small className="text-danger">
                {errors.expiryDate?.message}
              </small>
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group">
              <label>Trade</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Trade"
                {...register("trade")}
              />
              <small className="text-danger">{errors.trade?.message}</small>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Type</label>
              <select className="form-control" {...register("type")}>
                <option value="">Select Type</option>
                {!isEditMode && <option value={0}>New</option>}
                {isEditMode && <option value={1}>Renew</option>}
                {isEditMode && <option value={2}>Update</option>}
              </select>
              <small className="text-danger">{errors.type?.message}</small>
            </div>
          </div>

          <div className="col-12">
            <div className="form-group flex-end">
              <button
                type="button"
                className="my-button bg-secondary mx-2"
                onClick={() => handleClear()}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="my-button"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Saving..." : "Save"}
              </button>
            </div>
          </div>
        </div>
      </form>
    </section>
  );
};

export default IdCardForm;